"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useState } from "react";
import ProductCardAddToCartButton from "./ProductCardAddToCartButton";
import ProductPrice from "./ProductPrice";
import ProductImage from "./ProductImage";
import ProductReviews from "./ProductReviews";
import { Button, Modal } from "@mantine/core";
import ProductForm from "@/components/product/ProductPage/ProductForm";
import { usePathname } from "next/navigation";
import EarnPointsBadge from "@/components/EarnPointsBadge";
import PromoLabelChips from "@/components/product/PromoLabelChips";
import { labelsForProduct } from "@/lib/promoLabels";
import ProductLabelChips from "@/components/product/ProductLabelChips";
import { getShopConfig } from "@/server/shop/get-shop-config";
export default function ProductCard(t0) {
  const $ = _c(56);
  const {
    product
  } = t0;
  const pathname = usePathname();
  const defaultVariant = product?.variants?.[0];
  const [selectedVariant, setSelectedVariant] = useState(defaultVariant);
  let t1;
  if ($[0] !== defaultVariant?.option_values) {
    t1 = defaultVariant?.option_values || {};
    $[0] = defaultVariant?.option_values;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedOptions, setSelectedOptions] = useState(t1);
  const [quantity, setQuantity] = useState(1);
  const [open, setOpen] = useState(false);
  const hasVariants = product?.variants?.length > 1;
  const titlePaths = ["/collections", "/brands"];
  const isTitlePath = titlePaths.some(base => pathname === base || pathname.startsWith(base + "/"));
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getShopConfig();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const nshop = t2;
  const shopSlug = nshop.id;
  const isProductsExact = pathname === "/products";
  let t3;
  if ($[3] !== pathname) {
    t3 = pathname.startsWith("/products/") && pathname !== "/products";
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isProductsSubPath = t3;
  const t4 = `/products/${product.handle}`;
  const t5 = `Buy ${product.title}`;
  let t6;
  if ($[5] !== product) {
    t6 = <ProductImage product={product} />;
    $[5] = product;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
    t7 = <Link href={t4} title={t5}>{t6}</Link>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== product.labels) {
    t8 = <ProductLabelChips labels={product.labels} />;
    $[11] = product.labels;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="relative">{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = product?.brand?.brand_name;
  let t11;
  if ($[16] !== t10) {
    t11 = <div className="font-bold text-xs line-clamp-1 text-center">{t10}</div>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = `/products/${product.handle}`;
  let t13;
  if ($[18] !== isProductsExact || $[19] !== isProductsSubPath || $[20] !== isTitlePath || $[21] !== product.title) {
    t13 = isTitlePath || isProductsExact ? <h3 className="line-clamp-1 text-xs text-center">{product.title}</h3> : isProductsSubPath ? <div className="line-clamp-1 text-xs text-center">{product.title}</div> : <div className="line-clamp-1 text-xs text-center">{product.title}</div>;
    $[18] = isProductsExact;
    $[19] = isProductsSubPath;
    $[20] = isTitlePath;
    $[21] = product.title;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <Link href={t12} className="group-hover:underline group-hover:text-blue-800 font-heading">{t13}</Link>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  let t16;
  if ($[26] !== product) {
    t15 = <ProductReviews product={product} />;
    t16 = <ProductPrice product={product} />;
    $[26] = product;
    $[27] = t15;
    $[28] = t16;
  } else {
    t15 = $[27];
    t16 = $[28];
  }
  let t17;
  if ($[29] !== defaultVariant) {
    t17 = defaultVariant?.loyalty_points > 0 && <EarnPointsBadge points={defaultVariant.loyalty_points} />;
    $[29] = defaultVariant;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <hr className="mb-1 text-gray-300" />;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== hasVariants || $[33] !== product) {
    t19 = hasVariants ? <Button tt="uppercase" fullWidth={true} size="xs" onClick={() => setOpen(true)}>{shopSlug === "aspireeciguk" ? "Choose Options" : "Quick Buy"}</Button> : <ProductCardAddToCartButton product={product} />;
    $[32] = hasVariants;
    $[33] = product;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t11 || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17 || $[40] !== t19) {
    t20 = <div className="px-2 pb-1">{t11}{t14}{t15}{t16}{t17}{t18}{t19}</div>;
    $[35] = t11;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => setOpen(false);
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  const t22 = product?.title;
  let t23;
  if ($[43] !== product || $[44] !== quantity || $[45] !== selectedOptions || $[46] !== selectedVariant) {
    t23 = <ProductForm product={product} selectedVariant={selectedVariant} setSelectedVariant={setSelectedVariant} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} quantity={quantity} setQuantity={setQuantity} compact={true} setOpen={setOpen} />;
    $[43] = product;
    $[44] = quantity;
    $[45] = selectedOptions;
    $[46] = selectedVariant;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== open || $[49] !== t22 || $[50] !== t23) {
    t24 = <Modal opened={open} onClose={t21} size="xl" title={t22}>{t23}</Modal>;
    $[48] = open;
    $[49] = t22;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t20 || $[53] !== t24 || $[54] !== t9) {
    t25 = <div className="group relative rounded-lg bg-white outline outline-gray-200 border border-gray-200 flex flex-col gap-1 lg:gap-2 shadow-xs hover:shadow-lg hover:-translate-y-2 transition-all duration-300">{t9}{t20}{t24}</div>;
    $[52] = t20;
    $[53] = t24;
    $[54] = t9;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  return t25;
}